import { Component, OnInit, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { MasterPageComponent } from '../../../components/page/master-page/master-page.component'
declare let jQuery :any;


declare let mLayout: any;
@Component({
    selector: "app-header-nav",
	templateUrl: "./header-nav.component.html",
	styleUrls: ['./header-nav.component.css'],
    encapsulation: ViewEncapsulation.None,

})
export class HeaderNavComponent extends MasterPageComponent {

    menu = this.fetchMenu()


    ngOnInit() {}

    ngAfterViewInit() {
        // this._script.loadScripts('app-header-nav', ['assets/js/compressed.js']);
        // this._script.loadScripts('app-header-nav', ['assets/js/main.js']);

        //toggle mobile menu
	jQuery('.toggle_menu').on('click', function(){
		jQuery('.toggle_menu').toggleClass('mobile-active');
		jQuery('.page_header').toggleClass('mobile-active');
	});

	jQuery('.mainmenu a').on('click', function(){
		if (!jQuery(this).hasClass('sf-with-ul')) {
			jQuery('.toggle_menu').toggleClass('mobile-active');
			jQuery('.page_header').toggleClass('mobile-active');
		}
	});

	//side header processing
	var $sideHeader = jQuery('.page_header_side');
	if ($sideHeader.length) {
		var $body = jQuery('body');
		jQuery('.toggle_menu_side').on('click', function(){
			if (jQuery(this).hasClass('header-slide')) {
				$sideHeader.toggleClass('active-slide-side-header');
			} else {
				if(jQuery(this).parent().hasClass('header_side_right')) {
					$body.toggleClass('active-side-header slide-right');
				} else {
					$body.toggleClass('active-side-header');
				}
			}
		});
		// toggle sub-menus visibility on menu-side-click
		jQuery('ul.menu-side-click').find('li').each(function(){
			var $thisLi = jQuery(this);
			//toggle submenu only for menu items with submenu
			if ($thisLi.find('ul').length)  {
				$thisLi
					.append('<span class="activate_submenu"></span>')
					.find('.activate_submenu')
					.on('click', function() {
						var $thisSpan = jQuery(this);
						if ($thisSpan.parent().hasClass('active-submenu')) {
							$thisSpan.parent().removeClass('active-submenu');
							return;
						}
						$thisLi.addClass('active-submenu').siblings().removeClass('active-submenu');
					});
			} //eof sumbenu check
		});
		//hidding side header on click outside header
		jQuery('body').on('click', function( e ) {
			if ( !jQuery(e.target).closest('.page_header_side').length ) {
				$sideHeader.removeClass('active-slide-side-header');
				$body.removeClass('active-side-header slide-right');
			}
		});
	} //sideHeader check

        
        var $header = jQuery('.page_header').first();
        if ($header.length) {
            if (!$header.hasClass('transparent_header')) {
                menuHideExtraElements();
                $header.wrap('<div class="page_header_wrapper"></div>').parent().css({height: headerHeight}); //wrap header for smooth stick and unstick
    
                //for boxed layout - show or hide main menu elements if width has been changed on affix
                jQuery($header).on('affixed-top.bs.affix affixed.bs.affix', function ( e ) {
                    if( $header.hasClass('affix-top') ) {
                        $header.parent().removeClass('affix-wrapper affix-bottom-wrapper').addClass('affix-top-wrapper');
                    } else if ( $header.hasClass('affix') ) {
                        $header.parent().removeClass('affix-top-wrapper affix-bottom-wrapper').addClass('affix-wrapper');
                    } else if ( $header.hasClass('affix-bottom') ) {
                        $header.parent().removeClass('affix-wrapper affix-top-wrapper').addClass('affix-bottom-wrapper');
                    } else {
                        $header.parent().removeClass('affix-wrapper affix-top-wrapper affix-bottom-wrapper');
                    }
                    menuHideExtraElements();
                });
    
                //if header has different height on afixed and affixed-top positions - correcting wrapper height
                jQuery($header).on('affixed-top.bs.affix', function () {
                    $header.parent().css({height: $header.outerHeight()});
                });
            }
            // menuHideExtraElements();
            var headerHeight = $header.outerHeight();
    
            //get offset
            var headerOffset = 0;
            //check for sticked template headers
                headerOffset = $header.offset().top;
    
            jQuery($header).affix({
                offset: {
                    top: headerOffset,
                    bottom: 0
                }
            });
        }
    }


}

//hidding menu elements that do not fit in menu width
function menuHideExtraElements() {
	jQuery('#more-li').remove();
	var wrapperWidth = jQuery('.mainmenu_wrapper').width();
	var summaryWidth = 0;
	//get all first level menu items
	var $liElements = jQuery('.sf-menu > li');
	$liElements.removeClass('md-hidden');
	$liElements.each(function(index) {
		var elementWidth = jQuery(this).outerWidth();
		summaryWidth += elementWidth;
		if(summaryWidth >= wrapperWidth) {
			var $newLi = jQuery('<li id="more-li"><a>...</a><ul></ul></li>');
			jQuery($liElements[index-1]).before($newLi);
			var newLiWidth = jQuery($newLi).outerWidth(true);
			var $extraLiElements = $liElements.filter(':gt('+(index-2)+')');
			$extraLiElements.clone().appendTo($newLi.find('ul'));
			$extraLiElements.addClass('md-hidden');
			return false;
		}
	});
}


// WEBPACK FOOTER //
// ./src/app/theme/layouts/header-nav/header-nav.component.ts